import React, { useState } from 'react';

interface CodeDisplayModalProps {
  code: string;
  onClose: () => void;
  title?: string;
}

export function CodeDisplayModal({ code, onClose, title = 'Zugangscode generiert' }: CodeDisplayModalProps): JSX.Element {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Copy failed:', err);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content code-display-modal" onClick={e => e.stopPropagation()}>
        <h2>{title}</h2>

        <div className="code-display">
          <span className="code-value">{code}</span>
        </div>

        <p className="code-warning">
          Dieser Code wird nur einmal angezeigt. Bitte notieren Sie ihn jetzt!
        </p>

        <div className="modal-actions">
          <button className="btn btn-primary" onClick={handleCopy}>
            {copied ? 'Kopiert!' : 'Code kopieren'}
          </button>
          <button className="btn btn-secondary" onClick={onClose}>
            Schliessen
          </button>
        </div>
      </div>
    </div>
  );
}

export default CodeDisplayModal;
